import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptionsArgs, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { AlertService, CnsltnQuotModel, LgMessageModel, LatestInfoModel, Location, CfsModel } from './index';
import { ApiService } from '../services/api.service';
import { UserModel } from './index';
import { Country, Port, Airport, AirLine, OceanLine } from './index';
import { REST_API_REQUEST_CALL_URL } from '../utils/index';
import { FileUploader } from 'ng2-file-upload';
import * as bigdecimal from 'bigdecimal';
import { Util } from '../utils/index';
import { Moment } from 'moment';

declare var moment:any;

export class ConsultSearchOption {
  page: number = 0;
  delYn: number = 0;
  stusCd: number = 99;
  conditionText: string;
  conditionType: string = "ALL";
  startDt: string = moment().subtract(2, 'months').format('YYYYMMDD');
  endDt: string = moment().format('YYYYMMDD');
  isImpossible: number = 99;
  imexTp:number = 99;
}
 
@Injectable()
export class QuotationService {
  private headers : Headers = new Headers({ 'Content-Type': 'application/json' });

  public curCnsltnTab:number = 99;
  public searchOption:ConsultSearchOption = new ConsultSearchOption;
  public filterType:number;
  public sortType:string;

  constructor(private http: Http, 
    private router: Router, 
    private alertService: AlertService,
    private apiService:ApiService) { }

  
    
  getConsultList(params: any): Observable<any>{
    return this.apiService.get(REST_API_REQUEST_CALL_URL.GET_CONSULT_LIST_URL, params);

  }

  getConsultReport(reqNo:string): Observable<any> {
    return this.apiService.get(REST_API_REQUEST_CALL_URL.GET_CONSULT_REPORT_URL + reqNo);
  }

  postCargoPics(uploader: FileUploader, reqNo) {
    uploader.setOptions({
      url: REST_API_REQUEST_CALL_URL.POST_CONSULT_DOC + reqNo,
      additionalParameter: {
        docNm: 'cargoPic',
      },
      headers: [
        {name: 'tx-clientId', value : 'tradlinx'},
        {name: 'Authorization', value : 'Bearer ' + sessionStorage.getItem('_vcd')}
      ]
    });
    uploader.queue.forEach((elem) => {
      elem.alias = 'docFile';
    });
    uploader.uploadAll();
  }

  delCargoPics(reqNo, docId): Observable<any> {
    return this.apiService.post('consult/'+ reqNo +'/delDocument', {reqNo: reqNo, docId : docId});
  }

  postBooking(reqNo, quotNo): Observable<any> {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_REQ_BOOK + '/' + reqNo, {quotNo: quotNo}, true);
  }

  cancelBooking(reqNo): Observable<any> {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_CANCEL_BOOK, {reqNo: reqNo}, true);
  }

  cancelArrive(reqNo): Observable<any> {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_UPDATE_STUS_CD, {reqNo: reqNo, stusCd: 3}, true);
  }

  completeArrive(reqNo): Observable<any> {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_UPDATE_STUS_CD, {reqNo: reqNo, stusCd: 4}, true);
  }

  cancelTrans(reqNo): Observable<any> {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_UPDATE_STUS_CD, {reqNo: reqNo, stusCd: 4}, true);
  }

  completeTrans(reqNo): Observable<any> {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_UPDATE_STUS_CD, {reqNo: reqNo, stusCd: 5}, true);
  }



  

  getCntOfStusCdFromCnsltn(): Observable<any>{
    return this.apiService.get(REST_API_REQUEST_CALL_URL.GET_CONSULT_STUS_CD_CNT_URL);
  }

  postTempFile(reqNo, docLst): Observable<any> {
    return this.apiService.post('consult/' + reqNo + '/reqDocument', {docList: docLst});
  }

  reqDocUploadFile(uploader: FileUploader, reqNo, docNm, docId) {
    uploader.setOptions({
      url: REST_API_REQUEST_CALL_URL.BASE_URL + '/consults/' + reqNo + '/reqDocuments/' + docId,
      additionalParameter: {
        docNm: docNm,
        docId: docId
      },
      headers: [
        {name: 'tx-clientId', value : 'tradlinx'},
        {name: 'Authorization', value : 'Bearer ' + sessionStorage.getItem('_vcd')}
      ]
    });
    uploader.queue.forEach((elem) => {
      elem.alias = 'docFile';
    });
    uploader.uploadAll();
  }

  postFiles(uploader: FileUploader, reqNo, docNm, docId) {
    uploader.setOptions({
      url: REST_API_REQUEST_CALL_URL.POST_CONSULT_DOC + reqNo,
      additionalParameter: {
        docNm: docNm,
        docId: docId
      },
      headers: [
        {name: 'tx-clientId', value : 'tradlinx'},
        {name: 'Authorization', value : 'Bearer ' + sessionStorage.getItem('_vcd')}
      ]
    });
    uploader.queue.forEach((elem) => {
      elem.alias = 'docFile';
    });
    uploader.uploadAll();
  }

  deleteFile(docId, reqNo, type?) {
    return this.apiService.post('consult/'+ reqNo +'/delDocument', {docId: docId, reqNo: reqNo, type:type});
  }

  postPickUp(reqNo, pickUp) {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_PICKUP + '/' + reqNo, pickUp, true);
  }

  postBookingApproval(reqNo) {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_BOOKING_APPROVAL + '/' + reqNo);
  }
  
  saveBookingSheet(reqNo, bookingSheetModel: BookingSheetModel, cnsltnQuotRouteList: Array<any>) {
    let body = {bookingSheetModel: bookingSheetModel, cnsltnQuotRouteList: cnsltnQuotRouteList};
    return this.apiService.post('admin/consult/book', body);
  }

  saveShippingAdvice(reqNo, cnsltnShpnadvModel: CnsltnShpnadvModel, cnsltnQuotRouteList: Array<any>) {
    let body = {cnsltnShpnadvModel: cnsltnShpnadvModel, cnsltnQuotRouteList: cnsltnQuotRouteList};
    return this.apiService.post('admin/consult/shippingadvice', body);
  } 

  getQuotRoute(reqNo, quotNo) {
    return this.apiService.get(REST_API_REQUEST_CALL_URL.GET_QUOT_ROUTE + reqNo + '/' + quotNo);
  }

  postComment(reqNo, cmnt) {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_COMMENT, {reqNo : reqNo, cmnt: cmnt}, true);
  }

  postTrucking(body, reqNo) {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_TRUCK + '/' + reqNo, body, true);
  }

  postBookTruck(yOrNo, reqNo) {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_BOOK_TRUCK, {truckingYn: yOrNo, reqNo: reqNo}, true);
  }

  postShipTruck(yOrNo, reqNo) {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_SHIP_TRUCK, {truckingYn: yOrNo, reqNo: reqNo}, true);
  }

  postCntrLst(cntrList, reqNo) {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CNTR_LIST + reqNo, {cntrList:cntrList}, true);
  }

  postBlNo(mBlNo, hBlNo, reqNo) {
    let body = {mBlNo: mBlNo, hBlNo: hBlNo, blYy: ""};
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_BL_NUMBER + reqNo, body, true);
  }

  cancelConsultQuot(quotNo){
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_CONSULT_QUOT_CANCEL + quotNo);
  }

  postQuotRoute(reqNo, routes) {
    return this.apiService.post(REST_API_REQUEST_CALL_URL.POST_QUOT_ROUTE + reqNo, routes, true);
  }

  getTracking(reqNo) {
    return this.apiService.get(REST_API_REQUEST_CALL_URL.GET_CONSULT_TRACK + reqNo);
  }

  postSendEmailLiner(reqNo){
    return this.apiService.post('admin/consult/emails', {reqNo:reqNo, type:"LINER_SAVE"}, true);
  }

  initSearchOption(){
    this.filterType = null;
    this.sortType = null;
    this.searchOption = new ConsultSearchOption();
  }

  addComment(reqNo, comment:NewComment){
    return this.apiService.post('admin/consult/comment', comment, true);
  }

  rejectBooking(reqNo, comment:NewComment){
    return this.apiService.post('admin/consult/refuse', comment, true);
  }

  static getImOrPossible(value:String):string{

    let name:string = '';
    switch (value) {
      case 'POSSIBLE':
        name = '가능';
        break;
      case 'IMPOSSIBLE':
        name = '불가능';
        break;
    
      default:
        break;
    }

    return name;
  }

  static getStusNm(value:number):string{  

    let name:string = '';

    switch (value) {
      case 0:
        name = '견적 요청';
        break;
      case 1:
        name = '견적 참여';
        break;
      case 2:
        name = '부킹 요청';
        break;
      case 3:
        name = '진행중';
        break;
      case 4:
        name = '도착 완료';
        break;
      case 5:
        name = '운송 완료';
        break;
    
      default:
        break;
    }

    return name;
  }

  static getStusNmByCd(value:number):string{

    let name:string = '';

    switch (value) {
      case -2:
        name = '요청 대기';
        break;
      case -1:
        name = '견적 요청';
        break;
      case 0:
        name = '견적 확인';
        break;
      case 1:
        name = '견적 참여';
        break;
      case 2:
        name = '부킹 요청';
        break;
      case 3:
        name = '진행중';
        break;
      case 4:
        name = '도착 완료';
        break;
      case 5:
        name = '운송 완료';
        break;

      default:
        break;
    }

    return name;
  }

}

export class CnsltnReqPageModel {
  dataLst: Array<CnsltnReqModel>;
  noOfElems: number;
  pageNo: number;
  size: number;
  totalElems: number;
  totalPages: number;
}

export class CnsltnReqModel {
  blYy: string;
  cnfrmDtm: string;
  delDtm: string;
  delYn: number;
  desAdrs: string;
  desCntryCd: string;
  desCntryNm: string;
  desLatitude: number;
  desLocationId: number;
  desLongitude: number;
  desAdrsPiece:string;
  desTp: number;
  hblNo: string;
  imexTp: number;
  inctms: string;
  linerNm: string;
  mblNo: string;
  orgAdrs: string;
  orgAdrsPiece:string;
  orgCntryCd: string;
  orgCntryNm: string;
  orgLatitude: number;
  orgLocationId: number;
  orgLongitude: number;
  orgTp: number;
  other: string;
  quotCnt: number;
  quotNo: string;
  receiver: string;
  recvAdmin: string;
  recvAdminNm: string;
  recvAdminTel: string;
  reqDtm: string;
  reqNo: string;
  reqSrvcLst: Array<string>
  reqTp: number;
  sender: string;
  stackYn: number;
  stuffYn: number;
  stusCd: number;
  transCfsYn: number;
  transExptDt: string;
  transNm: string;
  transTp: number;
  user: UserModel;
  vgmYn: number;
  
  crgoLst:Array<CnsltnReqCrgoModel>;

  isImpossible:number;
  impsbRsnCd:number;
  impsbRsnDscrt:String;
  isRegLiner:String;
  reqQuotCorpNm:string;
  
}

export class CnsltnReqCrgoModel {
cbm: number;
commodity: string;
count: number;
crgoSeq: number;
crgoSz: string;
crgoTp: string;
dgYn: number;
height: number;
hsCode: string;
length: number;
maxTemp: number;
minTemp: number;
pkgUnit: number;
reqNo: string;
reqTp: number;
rfYn: number;
tempUnit: string;
value: number;
valueUnit: string;
ventilation: string;
volUnit: string;
weight: number;
wghtUnit: string;
width: number;
cw: number;
}

export class ConsultReportModel{
  public cnsltnCmnt:any;
  public cnsltnQuotLst:Array<CnsltnQuotModel>;
  public cnsltnReq:CnsltnReqModel;
  public crncyRateLst:Array<CrncyRateLstModel>;
  constructor(){}
}

export class CrgoLstModel{
  public reqNo:string;
  public commodity:string;
  public count:bigdecimal.BigDecimal;
  public crgoTp:string;
  public crgoSz:string;
  public weight:bigdecimal.BigDecimal;
  public width:bigdecimal.BigDecimal;
  public height:bigdecimal.BigDecimal;
  public length:bigdecimal.BigDecimal;
  public value:number;
  public cbm:bigdecimal.BigDecimal;
}

export class CrncyRateLstModel{
  public cntryCd:string;
  public crncyCd:string;
  public krwPerUnit:number;
  public stndDt:string;
  public unitPerKrw:number;
}

export enum NodeType {
  ORIGIN = 0, POL, TSPORT, POD, DESTINATION, NODE, RAIL, DOOR, PORT, AIRPORT
}
export enum ModeType {
  VESSEL = 0, AIRPLANE, TRUCK, RAIL, BARGE, NEW
}

export class RouteModel{
  public routeId:number;
  public quotNo:string;
  public typeCd:NodeType;
  public seq:number;
  public location:Location
  public locationAdrs:string;
  public modeNm:string;
  public modeCd:ModeType = ModeType.NEW;
  public linerCd:string;
  public linerNm:string;
  public latitude:number;
  public longitude:number;
  public cntryCd:string;
}

export class CnsltnQuotRouteModel extends RouteModel{
  
  public quotation:any;
  public typeNm:string;
  public cntryNm:string;
  public inDt:string;
  public outDt:string;
  public modeId:number;
  public modeNm:string;
  public modeDtl:string;
  public remark:string;
  public transTp: number;
    
  public countries: Array<Country> = [];
  public ports: Array<Port> = [];
  public airports: Array<Airport> = [];
  public airLines: Array<AirLine> = [];
	public oceanLines: Array<OceanLine> = [];

  constructor(countries: Array<Country>, ports: Array<Port>, airports: Array<Airport>, airLines: Array<AirLine>, oceanLines: Array<OceanLine>){
    super();
    
    this.countries = countries;
    this.ports = ports;
    this.airports = airports;
    this.airLines = airLines;
    this.oceanLines = oceanLines;
  }


  // getRouteModel():RouteModel{
  //   let route:RouteModel = <RouteModel>this;
  //   console.log("super :", route);
  //   return route;
  // }
}
export class PickUpModel {
  public pickupDt: string;
  public pickupTm: string;
  public pickupAdrs: string;
}

export class BookingSheetModel {
  public cnsltnBookId: number; // 신규 입력일 경우 null
  public reqNo: string;
  public bookingNo: string;
  public blType:number;
  public docCloseDt: string;
  public docCloseTm: string;
  public vgmCloseDt: string;
  public vgmCloseTm: string;
  public cargoCloseDt: string;
  public cargoCloseTm: string;
  public emptyCfs: CfsModel;
  public emptyCfsRmk: string;
  public inCfs: CfsModel;
  public inCfsRmk:string;
}

export class TruckListModel {
  public cnsltnTruckId: number;
  public reqNo: string;
  public driver: string;
  public tel: string;
  public carNo: string;
  public cntrList: Array<CnsltnCntrModel>;
}

export class CnsltnCntrModel {
  public cnsltnCntrId: number;
  public reqNo: string;
  public cnsltnTruckId: number;
  public cntrNo: string;
  public sealNo: string;
}

export class CnsltnShpnadvModel{
  public cnsltnShpnAdvId: number;
  public reqNo: string;
  public demurrageDay: number;
  public storageDay: number;
  public detentionDay: number;
  public destCfs: CfsModel;
  public destCfsRmk: string;
  public truckingYn: number;
}

export class RouteEditModel {
  public routeId: number;
  public quotNo: string;
  public typeCd: number;
  public typeCdNm: string;
  public seq: number;
  public location: Location;
  public locationAdrs: string;
  public inDt: string;
  public outDt: string;
  public modeCd: number;
  public modeCdNm: string;
  public linerCd: string;
  public linerNm: string;
  public modeId: number;
  public modeNm: string;
  public modeDtl: string;
  public remark: string;
  public latitude: number;
  public longitude: number;
  
}

export class NewComment {
  reqNo: string;
  quotNo: string;
  cmntType: number; // 0 : old , 1:cmnt(일반 코멘트), 2:refusal (거절사유)
  corpId: number;
  cmnt: string;
}

export class CnsltnFwdrModel {
  cnsltnFwdrId:number;
  corpId:number;
  corpNm:string;
  email:string;
  managerNm:string;
  mobile:string;
  stusNm:string;
  stusCd:number;
  cnsltnImOrPossible:string
  reqNo:string;
  delYn:boolean = false;
  emailReceiveYn:boolean = true;
}

export class QuotEntryCorps {
  corpId:number;
  status:string;
}


// WEBPACK FOOTER //
// ./src/app/services/quotation.service.ts